// utils/email.ts

import { IEmailContentType } from '@publishing-engine/domain/models/email-templates';
import { IEmailCommandPayload } from '@publishing-engine/domain/types/email-template';
import { IEmailFormType } from '../components/EmailModule/EditEmailTemplate';

type RecipientInput = { text: string }[] | undefined;

export interface RawRecipients {
  to?: RecipientInput;
  cc?: RecipientInput;
  bcc?: RecipientInput;
}

export function normalizeRecipients(
  recipients: RawRecipients,
  overrideTo?: string[]
): IEmailContentType['recipients'] {
  const map = (list?: RecipientInput): string[] =>
    Array.isArray(list) ? list.map(i => i.text.trim()) : [];

  const normalized = {
    to: overrideTo ?? map(recipients?.to),
    cc: map(recipients?.cc),
    bcc: map(recipients?.bcc)
  };

  return normalized;
}

export function buildEmailPayload(
  emailContent: IEmailFormType,
  overrideTo?: string[]
): IEmailCommandPayload {
  return [
    {
      ...emailContent,
      recipients: normalizeRecipients(emailContent.recipients, overrideTo)
    }
  ];
}

export const extractEmailsFromTags = (tags?: { text?: string }[]): string[] => {
  return tags ? tags.map(tag => tag?.text ?? '') : [];
};
